<uib-accordion close-others="oneAtATime">
    <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}  | orderBy: '-_id'"
         is-open="status.isOpen[$index]" class="panel-warning">
        <!-- exam header -->
        <uib-accordion-heading>
            <div class="row">
                <div class="col-xs-12 col-sm-9">
                    <h4>
                        <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index];"><i class="fa fa-caret-up"></i></span>
                        <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index];"><i class="fa fa-caret-down"></i></span>
                        &nbsp;{{exam.template.displayname}}  vom {{exam.created | moment: 'lll'}}
                        <span ng-show="exam.files.length > 0">, {{exam.files.length}} <i class="fa fa-image"></i></span>
                    </h4>
                </div>
                <div class="col-xs-12 col-sm-3" style="text-align: right">
                    <h4>
                        <!-- PDF ansicht button-->
                        <a class="btn btn-info btn-sm" ng-show="exam.postediting === true" ng-click="$event.stopPropagation();"
                           href="/routes/pdfprinter/exampreview?patientid={{exam.patientid}}&examid={{exam._id}}&doctype=examfinding"
                           target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>
                        <sprhelp tip="PDF Vorschau" descref="vm.sprpreview"  ng-show="exam.postediting === true" ></sprhelp>
                        <a class="btn btn-primary btn-sm" ng-hide="exam.postediting === true"
                           href="/routes/files/pdfreader/exam.fileid"  ng-click="$event.stopPropagation();"
                           target="_blank" uib-tooltip="PDF Ansicht"><i class="fa fa-eye"></i></a>
                        <a class="btn btn-primary btn-sm" ng-hide="exam.postediting === true"
                           href="/routes/files/pdfdownload/exam.fileid"  ng-click="$event.stopPropagation();"
                           target="_blank" uib-tooltip="PDF Download"><i class="fa fa-download"></i></a>
                    </h4>
                </div>
            </div>
        </uib-accordion-heading>
        <!-- exam data -->
        <div class="row">
            <div class="col-xs-12">
                <!--<examview exam="exam" ng-if="vm.showview(exam.open, editexam[$index])"></examview>-->
                <!--<div class="spacer-sides" ng-if="vm.showeditor(exam.open, editexam[$index])"></div>-->
                <div class="spacer-top spacer-bottom btn btn-primary" ng-click="vm.showexam[$index]=true" ng-if="!vm.showexam[$index] && $index > 2 ">
                    Untersuchungsdetails laden
                </div>
                <postexameditor ng-if="vm.showexam[$index] || $index < 3" exam="exam" ></postexameditor>

            </div>
        </div>
    </div>  <!-- exam in openConsult.examinations -->
</uib-accordion>